import React from 'react';

import classNames from 'classnames';

import * as classes from './style.module.scss';

export const Disclaimer: React.FC = ({ children }) => {
  return (
    <div className={classNames(classes.root, 'disclaimer')}>{children}</div>
  );
};
